export {default as drag} from "./src/drag";
export {default as dragDisable, yesdrag as dragEnable} from "./src/nodrag";



//////////////////
// WEBPACK FOOTER
// ./~/d3-drag/index.js
// module id = 190
// module chunks = 0